import { createAction, props } from "@ngrx/store";

import { AchAccountInfo } from "../../definitions/ach-account-info";
import { AchFundingRequest } from "../../definitions/ach-funding-request";
import { FailState } from "../models/fail-state";

export class ConsumerAchActions {
	static readonly TYPES = {
		fundRequested: "[Consumer ACH] Fund Requested",
		funded: "[Consumer ACH] Funded",
		fundFailed: "[Consumer ACH] Fund Failed",
		accountRetryRequested: "[Consumer ACH] Account Retry Requested",
		accountRetrySucceeded: "[Consumer ACH] Account Retry Succeeded",
		accountRetryFailed: "[Consumer ACH] Account Retry Failed",
		documentRetryRequested: "[Consumer ACH] Document Retry Requested",
		documentRetrySucceeded: "[Consumer ACH] Document Retry Succeeded",
		documentRetryFailed: "[Consumer ACH] Document Retry Failed"
	};
	static readonly fundRequested = createAction(
		ConsumerAchActions.TYPES.fundRequested,
		props<{ achFundingRequest: AchFundingRequest }>()
	);
	static readonly funded = createAction(ConsumerAchActions.TYPES.funded);
	static readonly fundFailed = createAction(
		ConsumerAchActions.TYPES.fundFailed,
		props<FailState>()
	);
	static readonly accountRetryRequested = createAction(
		ConsumerAchActions.TYPES.accountRetryRequested,
		props<{ request: AchAccountInfo }>()
	);
	static readonly accountRetrySucceeded = createAction(
		ConsumerAchActions.TYPES.accountRetrySucceeded
	);
	static readonly accountRetryFailed = createAction(
		ConsumerAchActions.TYPES.accountRetryFailed,
		props<FailState>()
	);
	static readonly documentRetryRequested = createAction(
		ConsumerAchActions.TYPES.documentRetryRequested,
		props<{ doc: FormData; docType: string; benOwnerId?: string }>()
	);
	static readonly documentRetrySucceeded = createAction(
		ConsumerAchActions.TYPES.documentRetrySucceeded
	);
	static readonly documentRetryFailed = createAction(
		ConsumerAchActions.TYPES.documentRetryFailed,
		props<FailState>()
	);
}
